<template>
    <div>
       <v-toolbar :class="styleClass" dark v-show="boxBool || showBoxZoom">
            <v-toolbar-title>Box Tools:</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="deleteBox" v-tooltip:top="{ html: 'Delete' }" icon><v-icon>&#xE872;</v-icon></v-btn>
            <v-btn @click="zoomIn" v-tooltip:top="{ html: 'Zoom In' }" icon><v-icon>&#xE8FF;</v-icon></v-btn>
            <v-btn @click="zoomOut" v-tooltip:top="{ html: 'Zoom Out' }" icon><v-icon>&#xE900;</v-icon></v-btn>
        </v-toolbar>
    </div>
</template>

<script>
import eXcYteD3 from './eXcYteD3.js';

export default {
    props: [ 'styleClass' ],
    data: function () {
        return {
            showBoxZoom: false
        };
    },
    computed: {
        boxBool: function () {
            return this.$store.getters.getBoxBool;
        }
    },
    methods: {
        zoomIn: function () {
            eXcYteD3.zoomIn();
            this.showBoxZoom = true;
        },
        zoomOut: function () {
            eXcYteD3.zoomOut();
            this.showBoxZoom = false;
        },
        deleteBox: function () {
            eXcYteD3.deleteBox();
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// boxTools.vue?013cd1aa